<template>
	<v-dialog
		v-model="setdialog.dialog"
		width="100%"
		max-width="600"
		persistent
		content-class="bottomShow"
		transition="dialog-bottom-transition"
	>
		<div class="exitBtn">
			<v-btn icon @click=";(setdialog.dialog = false), (phoneAuth = false)">
				<v-icon size="35px" color="white">
					mdi-close-circle
				</v-icon>
			</v-btn>
		</div>
		<v-card class="dialogStart" v-if="setdialog.step1">
			<!-- title -->
			<div class="titleSlide">
				<!-- text -->
				<v-icon @click="backStep" size="25" class="title-icon">mdi-chevron-left</v-icon>
				<v-spacer />
				<h2 class="ml-n7">
					<span v-if="this.$route.name !== 'reservedirect'">
						참여하기
					</span>
					<span v-else>
						방문등록
					</span>
				</h2>

				<v-spacer />
				<!-- icon -->
			</div>
			<div class="dialog-content">
				<div v-if="step1">
					<p class="campaigntitle">
						{{ $store.state.reservedayData.title }}
					</p>
					<!-- <div v-show="$route.name !== 'reserve_waiting'" v-if="$route.name !== 'reserve_direct'">
						<v-divider class="startDivider my-3" />
						<span class="greyTxt mr-5">기간</span>
						<span class="smallTxt" v-if="$store.state.reservedayData">
							{{ $store.state.reservedayData.sdate | moment('YYYY-MM-DD') }} ~
							{{ $store.state.reservedayData.edate | moment('YYYY-MM-DD') }}
						</span>
					</div> -->
					<v-divider class="startDivider mt-3 mb-2" />
					<termsAgreeTemp :urlInfo="$route.path" :changeBtn="changeBtn" style="margin-bottom: 20px;" />
				</div>
				<div v-if="step1">
					<p class="guideTxt">
						{{ $store.state.reservedayData.title }}
						{{
							reservedaysData.loginType !== 'kakao'
								? '방문등록을 위해 성명, 휴대폰번호를 입력해 주시기 바랍니다.'
								: '을 위해 카카오로 신청하기를 클릭하세요.'
						}}
					</p>
					<div class="text-center" v-if="reservedaysData.loginType === 'kakao'">
						<a id="reauthenticate-popup-btn" @click="clickNext" v-if="nomalJoin">
							<img src="/image/KakaoTalk_btn2.png" width="270" />
						</a>
					</div>
					<div v-else-if="reservedaysData.loginType === 'phone'">
						<txtField :txtField="setdialog.nametxtField" v-model="setdialog.nametxtField.value" @input="disableNext()"></txtField>
						<v-layout class="mt-2">
							<v-flex xs3>
								<select-box :sel="setdialog.numSel" @change="change"></select-box>
							</v-flex>
							<v-flex xs9 class="pl-3">
								<txtField :txtField="setdialog.numtxtField" v-model="setdialog.numtxtField.value" @input="disableNext()"></txtField>
							</v-flex>
						</v-layout>
						<!-- bottom -->
						<v-layout class="mt-5" justify-center>
							<btn
								btn_txt="전화번호 인증하기"
								:btn="nextBtn"
								@click="clickNextPhoneAuth()"
								:style="
									`background-color:${$store.state.PointColor7}; color:${nextBtn.class === 'customBtn' ? $store.state.PointColor8 : ''}`
								"
							></btn>
						</v-layout>
						<div v-show="phoneAuth" class="mt-4">
							<p class="guideTxt">
								문자로 전송된 인증번호를 입력해주세요.
							</p>
							<txtField :txtField="setdialog.phonetxtField" v-model="setdialog.phonetxtField.value"></txtField>
							<v-layout class="mt-5" justify-center>
								<btn
									btn_txt="인증하기"
									:btn="nextBtn"
									@click="clickNext()"
									:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}`"
								></btn>
							</v-layout>
						</div>
					</div>
					<div v-else>
						<txtField :txtField="setdialog.nametxtField" v-model="setdialog.nametxtField.value" @input="disableNext()"></txtField>
						<v-layout class="mt-2">
							<v-flex xs3>
								<select-box :sel="setdialog.numSel" @change="change"></select-box>
							</v-flex>
							<v-flex xs9 class="pl-3">
								<txtField :txtField="setdialog.numtxtField" v-model="setdialog.numtxtField.value" @input="disableNext()"></txtField>
							</v-flex>
						</v-layout>
						<!-- bottom -->
						<v-layout class="mt-5" justify-center>
							<btn
								:btn_txt="
									$route.name === 'reservedirect'
										? '방문등록'
										: $route.name === 'reserve_waiting'
										? '상담신청'
										: reservedaysData.btnText
										? reservedaysData.btnText
										: '시작하기'
								"
								:btn="nextBtn"
								@click="clickNext()"
								:style="
									`background-color:${$store.state.PointColor7} !important; color:${
										nextBtn.class === 'customBtn' ? $store.state.PointColor8 : $store.state.PointColor8
									}`
								"
							></btn>
						</v-layout>
					</div>
				</div>
			</div>
		</v-card>

		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal1" :infoInsert="infoInsert" />
	</v-dialog>
</template>
<script>
import { alertModal5, btn, selectBox, termsAgreeTemp, txtField } from '@/components/index'
export default {
	components: {
		btn,
		alertModal5,
		termsAgreeTemp,
		txtField,
		selectBox,
	},
	props: {
		nextStep: Function,
		setdialog: Object,
		title: String,
		reservedaysData: Object,
		// noInputBox: Boolean,
	},
	data() {
		return {
			phoneAuth: false,
			nomalJoin: true,
			step1: true,
			step2: false,
			nametxtField: { value: '', outlined: true, placeholder: '성명을 입력하세요.' },
			numSel: { value: '010', outlined: true, class: 'selectNum', items: ['010', '011', '016', '017'] },
			numtxtField: {
				type: 'Number',
				value: '',
				outlined: true,
				placeholder: '숫자만 입력하세요',
				onlyNumber: true,
				maxlength: 8,
				max: 99999999,
			},

			nowSurvey: { num: 0 },
			// --- date picker --
			picker: { date: '', allowedDates: '2021-5-30' },
			// --- 시간 선택 버튼 ---
			timeData: [],
			selectedTime: '',
			// --- 버튼 ---
			cancelBtn: {
				class: 'cancel',
			},
			nextBtn: {
				class: 'disabledBtn',
				width: '100%',
				disabled: true,
				block: true,
			},
			nextBtn1: {
				class: 'selectBtn',
				width: '100%',
				disabled: true,
				color: '',
				block: true,
			},
			nextBtn2: {
				class: 'Btn',
				width: '270',
				height: '40.5',
				disabled: false,
				block: false,
			},
			closeBtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			reseveCancel: {
				class: 'cancel',
				block: true,
			},
			reserveChange: {
				class: 'saveBtn',
				block: true,
			},
			alertModal: {
				dialog: false,
				text: '약관을 선택해주세요.',
				reddot: true,
			},
			alertModal1: {
				dialog: false,
				text: '약관을 선택해주세요.',
				reddot: true,
				nextStep: true,
			},
			okaySetDialog: {
				dialog: false,
				text: '',
				title: '완료',
			}, // 캠페인 완료 후 나오는 모달
			// --- 캠페인 명 ---
			campaignName: 'TEST CAMPAIGN MODELHOUSE',
			reserveChangeOn: false,
			message: '',
			messageData1: {}, // create / update 알림톡 데이터
			messageData2: {}, // delete 알림톡 데이터
		}
	},
	created() {},
	methods: {
		loginFormWithKakao() {
			if (this.$store.state.check3.value) {
				this.$store.state.loading = true
				let data = false
				let phone
				let name
				window.Kakao.Auth.loginForm({
					success: function() {
						window.Kakao.API.request({
							url: '/v2/user/me',
							success: function(response) {
								phone = response.kakao_account.phone_number
								name = response.kakao_account.profile.nickname

								data = true

								// this.nextStep()
							},
							fail: function(error) {
								clearInterval(loginInterval)
								alert('카카오 로그인 오류 발생 새로고침 후 다시 실행해 주세요(1)')
								console.log(error)
							},
						})
					},
					fail: function(err) {
						alert('카카오 로그인 오류 발생 새로고침 후 다시 실행해 주세요(0)')
						console.log(err)
					},
				})
				var loginInterval = setInterval(() => {
					if (data) {
						clearInterval(loginInterval)
						let number = phone.replace('+82 ', '0').replace(/-/g, '')

						this.setdialog.numtxtField.value = number.substr(3)
						this.setdialog.numSel.value = number.substr(0, 3)
						this.setdialog.nametxtField.value = name

						this.closeStart()
						this.$store.state.loading = false
					}
					this.$store.state.loading = false
				}, 500)
			}
		},
		changeBtn() {
			if (this.$store.state.check3.value && this.setdialog.numtxtField.value.length > 6 && this.setdialog.nametxtField.value !== '') {
				this.nextBtn.class = 'customBtn'
			} else {
				this.nextBtn.class = 'disabledBtn'
				// this.nextBtn1.color = this.$store.state.PointColor7
			}
		},
		disableNext() {
			if (this.$store.state.check3.value && this.setdialog.numtxtField.value.length > 6 && this.setdialog.nametxtField.value !== '') {
				this.nextBtn.class = 'customBtn'
				// this.nextBtn.color = this.$store.state.PointColor7
			} else {
				this.nextBtn.class = 'disabledBtn'
			}
			// this.reserveDialog.name = this.nametxtField.value
		},
		createSendSm(phone) {
			var randomCode = Math.floor(Math.random() * 1000000) + 100000
			if (randomCode > 1000000) {
				randomCode = randomCode - 100000
			}
			var message = `[전화번호 인증] 휴대전화 인증번호는 [${randomCode}] 입니다.`
			if (String(this.reservedaysData.business.id) === '15') message = `[청라 피크원 인증] 휴대전화 인증번호는 [${randomCode}] 입니다.`
			else if (String(this.reservedaysData.business.id) === '18')
				message = `[신분평 더웨이시티 인증] 휴대전화 인증번호는 [${randomCode}] 입니다.`

			const data = {
				receiver: phone,
				message: message,
				authCode: String(randomCode),
				sender:
					this.$route.params.code === 'pickone'
						? process.env.VUE_APP_SENDER
						: String(this.reservedaysData.business.id) === '15'
						? '1551-6880'
						: String(this.reservedaysData.business.id) === '18'
						? '1533-6100'
						: process.env.VUE_APP_SENDER,
				senderkey: process.env.VUE_APP_SENDERKEY,
				pay: this.$route.params.code === 'pickone' ? null : this.reservedaysData.business?.id,
			}
			this.$store
				.dispatch('createSendSm', data)
				.then(() => {})
				.catch(err => {
					alert('SMS 전송시 오류가 발생하였습니다. 다시 시도해 주세요.')
					console.log({ err })
				})
		},
		clickNextPhoneAuth() {
			// 설문에 약관 있는데 아무것도 선택하지 않은 경우
			// if (this.$store.state.check2.value === false) {
			// 	return (
			// 		(this.alertModal.dialog = true),
			// 		(this.alertModal.text =
			// 			'이용 약관동의을 선택하세요.\n동의 없이 진행시 분양정보 서비스를 제공해 드릴 수 없다는 점 양해 부탁드리며, 입력하신 개인정보는 알림톡 발송시에만 사용됨을 알려드립니다.')
			// 	)
			// } else
			if (this.$store.state.check3.value === false) {
				return (
					(this.alertModal.dialog = true),
					(this.alertModal.text =
						'개인정보 수집동의을 선택하세요.\n동의 없이 진행시 분양정보 서비스를 제공해 드릴 수 없다는 점 양해 부탁드리며, 입력하신 개인정보는 알림톡 발송시에만 사용됨을 알려드립니다.')
				)
				// } else if (this.$store.state.check4.value === false) {
				// 	return (
				// 		(this.alertModal.dialog = true),
				// 		(this.alertModal.text =
				// 			'고유식별 수집동의을 선택하세요.\n동의 없이 진행시 분양정보 서비스를 제공해 드릴 수 없다는 점 양해 부탁드리며, 입력하신 개인정보는 알림톡 발송시에만 사용됨을 알려드립니다.')
				// 	)
			} else {
				if (!this.setdialog.nametxtField.value) {
					return (this.alertModal.dialog = true), (this.alertModal.text = '이름을 입력해 주세요.')
				} else if (!this.setdialog.numtxtField.value) {
					return (this.alertModal.dialog = true), (this.alertModal.text = '전화번호를 입력해 주세요.')
				}
				this.phoneAuth = true
				this.createSendSm(this.setdialog.numSel.value + this.setdialog.numtxtField.value, this.setdialog.nametxtField.value)
			}
		},
		clickNext() {
			if (this.phoneAuth) {
				// 설문에 약관 있는데 아무것도 선택하지 않은 경우
				// if (this.$store.state.check2.value === false) {
				// 	return (
				// 		(this.alertModal.dialog = true),
				// 		(this.alertModal.text =
				// 			'이용 약관 동의을 선택하세요.\n동의 없이 진행시 분양정보 서비스를 제공해 드릴 수 없다는 점 양해 부탁드리며, 입력하신 개인정보는 알림톡 발송시에만 사용됨을 알려드립니다.')
				// 	)
				// } else
				if (this.$store.state.check3.value === false) {
					return (
						(this.alertModal.dialog = true),
						(this.alertModal.text =
							'개인정보 수집동의을 선택하세요.\n동의 없이 진행시 분양정보 서비스를 제공해 드릴 수 없다는 점 양해 부탁드리며, 입력하신 개인정보는 알림톡 발송시에만 사용됨을 알려드립니다.')
					)
					// } else if (this.$store.state.check4.value === false) {
					// 	return (
					// 		(this.alertModal.dialog = true),
					// 		(this.alertModal.text =
					// 			'고유식별 수집동의을 선택하세요.\n동의 없이 진행시 분양정보 서비스를 제공해 드릴 수 없다는 점 양해 부탁드리며, 입력하신 개인정보는 알림톡 발송시에만 사용됨을 알려드립니다.')
					// 	)
				} else {
					const data = {
						receiver: this.setdialog.numSel.value + this.setdialog.numtxtField.value,
						// sender: this.setdialog.nametxtField.value,
						authCode: String(this.setdialog.phonetxtField.value),
					}
					this.$store.dispatch('sendSms', data).then(res => {
						if (res.data.sendSms.length > 0) {
							this.setdialog.phonetxtField.value = ''
							this.phoneAuth = false
							this.closeStart()
						} else {
							this.alertModal.dialog = true
							this.alertModal.text = '인증번호가 틀립니다.'
						}
					})
				}
			} else {
				// 설문에 약관 있는데 아무것도 선택하지 않은 경우
				// if (this.$store.state.check2.value === false) {
				// 	return (
				// 		(this.alertModal.dialog = true),
				// 		(this.alertModal.text =
				// 			'이용 약관 동의을 선택하세요.\n동의 없이 진행시 분양정보 서비스를 제공해 드릴 수 없다는 점 양해 부탁드리며, 입력하신 개인정보는 알림톡 발송시에만 사용됨을 알려드립니다.')
				// 	)
				// } else
				if (this.$store.state.check3.value === false) {
					return (
						(this.alertModal.dialog = true),
						(this.alertModal.text =
							'개인정보 수집동의을 선택하세요.\n동의 없이 진행시 분양정보 서비스를 제공해 드릴 수 없다는 점 양해 부탁드리며, 입력하신 개인정보는 알림톡 발송시에만 사용됨을 알려드립니다.')
					)
					// } else if (this.$store.state.check4.value === false) {
					// 	return (
					// 		(this.alertModal.dialog = true),
					// 		(this.alertModal.text =
					// 			'고유식별 수집동의을 선택하세요.\n동의 없이 진행시 분양정보 서비스를 제공해 드릴 수 없다는 점 양해 부탁드리며, 입력하신 개인정보는 알림톡 발송시에만 사용됨을 알려드립니다.')
					// 	)
				} else {
					if (this.reservedaysData.loginType === 'kakao') {
						this.loginFormWithKakao()
					} else {
						this.closeStart()
					}
				}
			}
		},
		backStep() {
			if (this.step1 === true) {
				this.setdialog.dialog = false
				this.phoneAuth = false
			} else {
				this.step1 = true
				this.step2 = false
			}
			// }
		},
		closeStart() {
			this.nextStep()
			if (this.setdialog.nametxtField.value === '') {
				return
			}
			if (this.setdialog.numtxtField.value === '') {
				return
			}
			if (this.setdialog.numtxtField.value.length < 7) {
				return
			}
			setTimeout(() => {
				this.step1 = true
				this.step2 = false
			}, 500)
		},
		change() {},
		infoInsert() {
			if (this.reservedaysData.loginType === 'kakao') {
				this.loginFormWithKakao()
			} else {
				this.closeStart()
			}
		},
	},
}
</script>

<style lang="scss">
.exitBtn {
	top: 0;
	text-align: end;
	position: absolute;
	width: 100%;
	max-width: 600px;
	padding: 20px;
}
.dialogStart {
	.title {
		height: 60px;
		display: flex;
		align-items: center;
		background-color: #fdc85a;
		padding: 0 25px;

		h2 {
			color: white;
			font-size: 17px;
			font-weight: bold;
		}
		.title-icon {
			color: white;
		}
	}
	.titleSlide {
		display: flex;
		align-items: center;
		padding: 10px 25px 10px;

		h2 {
			font-size: 15px;
			font-weight: 600;
		}
	}
	.dialog-content {
		padding: 10px 25px 65px;
		.campaigntitle {
			font-weight: 500;
			font-size: 15px;
			margin-bottom: 0px !important;
		}
		.smallTxt {
			font-size: 13px;
			font-weight: 400;
		}
		.greyTxt {
			font-size: 13px;
			color: #787878;
		}
		.divider-dark {
			background-color: black;
		}
		.guideTxt {
			white-space: pre-line;
			font-size: 13.5px;
			font-weight: 400;
		}
	}
	.bottom {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
	.bottom2 {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
}

.dateGuideDay {
	font-size: 80%;
	font-weight: bold;
}
.contentName {
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 5px !important;
}
.v-btn--rounded {
	border-radius: 0;
}
.smallLabel {
	margin-top: 5px;
	.v-label {
		font-size: 14px !important;
		color: #a6a6a6 !important;
	}
}
.allAgree {
	margin-top: 5px;
	.v-label {
		font-size: 14px;
		font-weight: bold;
		color: #a6a6a6 !important;
	}
}
.layout {
	margin: 0px 0px 0px 0px !important;
}
.resCheck {
	font-size: 14px;
	font-weight: bold;
}
.infoCheck {
	color: #2a3c48;
	font-weight: bold;
	font-size: 16px;
	span {
		color: white;
		background-color: #2a3c48;
		padding: 5px 10px 5px 10px;
		font-size: 12px;
		border-radius: 5px;
		margin-right: 7px;
	}
}
.lastInfo {
	font-size: 14px;
	color: #4b4948;
	margin-bottom: 0px !important;
}
.place-title-strong {
	font-weight: bold !important;
	color: #006b8f;
}
.bottomShow {
	margin: 0px !important;
	align-self: flex-end !important;
	border-radius: 10px 10px 0px 0px !important;
}
.viewport-item {
	.item-style {
		width: 320px;
	}
}
.startDivider {
	border-color: #ececec !important;
}
</style>
